import _jsx2 from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { PRODUCT_TYPES } from 'constants/filters';
import { useSelectorProps } from 'hooks';
import { getFormattedSearchParams } from 'selectors';
import { newSearch, newPathname } from 'utils';
import messages from './messages';
import { SelectWrapper, SelectOption } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";

function RkoTypeSelect(_ref) {
  var defaultValueId = _ref.defaultValueId;
  var selectorProps = useSelectorProps();
  var searchParams = useSelector(function (state) {
    return getFormattedSearchParams(state, selectorProps);
  });
  var history = useHistory();
  var handleClick = useCallback(function (item) {
    return function () {
      if (defaultValueId === item) {
        return;
      }

      history.push({
        pathname: newPathname({
          params: selectorProps.params,
          newValues: {
            page: ''
          }
        }),
        search: newSearch({
          params: searchParams,
          newValues: {
            type: item !== PRODUCT_TYPES.all ? item : ''
          }
        })
      });
    };
  }, [selectorProps]);
  return /*#__PURE__*/_jsx2(SelectWrapper, {}, void 0, Object.values(PRODUCT_TYPES).map(function (item) {
    return /*#__PURE__*/_jsx2(SelectOption, {
      onClick: handleClick(item),
      $isActive: item === defaultValueId
    }, item, /*#__PURE__*/_jsx(FormattedMessage, _objectSpread({}, messages[item])));
  }));
}

export default /*#__PURE__*/memo(RkoTypeSelect);